import { ROLE } from "../shared/tagTypes";
import { baseApi } from "./base";

const companyApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [ROLE],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getRoles: builder.query({
        query: (payload) => ({
          url: "/roles",
          params: {
            ...(payload.companyId != undefined && {
              companyId: payload.companyId,
            }),
          },
        }),
        providesTags: [ROLE],
      }),      
    }),

    overrideExisting: false,
  });

export const {
  useGetRolesQuery,
  useLazyGetRolesQuery
} = companyApi;
